import { createApiHooks, schemaToQueryParameters } from '@apis/next/common';
import { PaginationType } from '@models/next/PaginationType';
import { PatchPartner, PostPartner, Partner } from '@models/next/Partner';
import { z } from 'zod';

export const dashboardPartnerApis = createApiHooks('/dashboard/partner', [
  {
    method: 'get',
    path: '/',
    parameters: schemaToQueryParameters(PaginationType),
    response: Partner.array(),
  },
  {
    method: 'post',
    path: '/',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostPartner,
      },
    ],
    response: Partner,
  },
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: Partner,
  },
  {
    method: 'patch',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
      {
        type: 'Body',
        name: 'body',
        schema: PatchPartner,
      },
    ],
    response: Partner,
  },
]);
